const RELOAD_FLAG_KEY = 'ct-panel-chunk-reload-attempted'
// If the app is still alive this long after a reload, treat it as successful
// and re-arm the guard so a later deploy can trigger another auto-reload.
const REARM_DELAY_MS = 10000

const isChunkLoadError = (message: string): boolean =>
  /Loading chunk [\w-]+ failed/i.test(message) ||
  /Loading CSS chunk [\w-]+ failed/i.test(message) ||
  message.includes('ChunkLoadError')

const reloadOnce = (): void => {
  if (sessionStorage.getItem(RELOAD_FLAG_KEY)) return

  sessionStorage.setItem(RELOAD_FLAG_KEY, '1')
  globalThis.location.reload()
}

// Stale tabs hold an index.html referencing hashed chunks that a new deploy has
// already deleted, so lazy-loaded routes/modules fail with ChunkLoadError until
// the user hard-reloads. Reload automatically, once, to pick up the new build.
export const registerChunkErrorReload = (): void => {
  globalThis.setTimeout(() => sessionStorage.removeItem(RELOAD_FLAG_KEY), REARM_DELAY_MS)

  globalThis.addEventListener('error', event => {
    if (isChunkLoadError(event.message ?? '')) reloadOnce()
  })

  globalThis.addEventListener('unhandledrejection', event => {
    const reason = event.reason
    const message = typeof reason === 'string' ? reason : reason?.message ?? ''

    if (isChunkLoadError(message)) reloadOnce()
  })
}
